import _ from 'lodash';
import services from '../../../services';
import types from './action-types';
import { getSimpleOffers } from './util';
const {
    coreAPIInstance: api,
    UserService
} = services;

const fetchOffers = (queryParams = {}) => ({
    asyncAction: () => api.offers.get(queryParams)
        .then((response) => {
            // Used in Google Tag Manager dataLayer
            const loanId = _.get(response, 'data.loanId', '');
            const underwritingCard = _.get(response, 'data.cardId', '');
            console.info({ loanId, underwritingCard });
            loanId && window.dataLayer.push({
                event: 'LOAN_OFFER_PRESENTED',
                loanId,
                underwritingCard
            });
            return response;
        })
        .catch((error) => {
            throw error;
        }),
    type: types.OFFERS_GET,
});


const fetchOffersAuthenticated = (queryParams = {}, loanId) => ({
    asyncAction: () => api.offers.getLoanOffers(queryParams, loanId)
        .then((response) => {
            const requestedAmount =  _.get(response, 'requestedAmount');
            const res = { data: getSimpleOffers(response) };
            if (requestedAmount) {
                res.data.customizedOffer = requestedAmount;
            }
            return res;
        })
        .catch((error) => {
            throw error;
        }),
    type: types.OFFERS_GET,
});


const pollWithAppRouterToken = (token=null) => ({
    asyncAction: (dispatch) => {
        dispatch({ type: types.OFFERS_GET_PENDING });
        return api.pollWithAppRouterToken(token)
            .then((response) => {
                const inquiryOffersUrl = _.get(response, 'data.inquiryOffersUrl');
                if (typeof inquiryOffersUrl === 'string' && inquiryOffersUrl.includes('?') && inquiryOffersUrl.includes('&')) {
                    window.location.href = inquiryOffersUrl;
                    const queryParams = {};
                    inquiryOffersUrl
                        .split('?')[1]
                        .split('&')
                        .forEach((queryParam) => {
                            const [key, value] = queryParam.split('=');
                            queryParams[key] = value;
                        });
                    
                    dispatch(fetchOffers(queryParams));
                }
                const user = _.get(response, 'data.user');
                user && UserService.set(user);
                return response;
            })
            .catch((error) => {
                const user = _.get(error, 'data.user');
                user && UserService.set(user);
                throw error;
            });
    },
    type: types.ROUTED_APPLICATION,
});


const pendingOffers = () => ({
    type: types.OFFERS_GET_PENDING
});

const receivedOffers = (res) => ({
    type: types.OFFERS_GET_SUCCESS,
    res,
});

export default {
    fetchOffers,
    pendingOffers,
    pollWithAppRouterToken,
    receivedOffers,
    fetchOffersAuthenticated,
};
